<div class="simple-card">
  <page-title></page-title>

  <div class="container-product-search m-t-40">
    <search-product (_onProductSelected)="setEntry($event)"></search-product>
  </div>

  <p class="m-t-12 m-b-0">{{ 'ndbsQuickOrder.uploadLimit' | cxTranslate }}</p>
</div>

<ng-container
  *ngIf="{
    entries: entries$ | async,
  } as content"
>
  @if (content.entries?.length) {
    <div class="container-list simple-card m-t-20">
      <quick-order-product-list [entries]="content.entries || []" [form]="form"></quick-order-product-list>
    </div>
  }

  <div class="ndbs-quick-order-actions actions">
    <div class="container-impex">
      <import-entries [form]="uploadForm" (_onChangeFile)="uploadItens($event)"></import-entries>

      <cx-export-order-entries
        [label]="'exportEntries.exportTemplate'"
        [btnClass]="'btn-outline-primary'"
        [InEnties$]="getFakeEntries()"
        [exportConfig]="exportConfigSampleTemplate"
      ></cx-export-order-entries>

      <ng-container *ngIf="entries$ | async as entries">
        <cx-export-order-entries [InEnties$]="getEntries()" [btnClass]="'btn-outline-primary'"></cx-export-order-entries>
      </ng-container>
    </div>

    @if (content.entries?.length) {
      <button class="btn btn-outline-danger btn-reset" (click)="openResetConfirmation()" title="Clear all entries">
        <span class="material-symbols-outlined d-flex m-r-4"> delete </span>

        {{ 'ndbsQuickOrder.actions.clearAllEntries' | cxTranslate }}
      </button>

      <button class="btn btn-primary" (click)="submitOrder()">
        <span class="material-symbols-outlined d-flex m-r-4"> shopping_cart_checkout </span>

        {{ 'ndbsQuickOrder.actions.addToCart' | cxTranslate }}
      </button>
    }
  </div>
</ng-container>
